import { Box, Typography } from '@mui/material';

import { NO_DATA_PLACEHOLDER } from '@occc/ui-design-system';

export type StoreConnectionStatus = 'Online' | 'Offline' | typeof NO_DATA_PLACEHOLDER;

const STATUS_STYLE: Record<StoreConnectionStatus, { bgcolor: string; color: string }> = {
  Online: { bgcolor: 'success.light', color: 'success.dark' },
  Offline: { bgcolor: 'error.light', color: 'error.dark' },
  'N/A': { bgcolor: 'default.main', color: 'text.secondary' },
};

// Backed by the authoritative BE `RetailerNetworkLocation.isOnline` field (nullable —
// null/undefined means status is unavailable/unknown).
export const getLocationConnectionStatus = (
  isOnline: boolean | null | undefined,
): StoreConnectionStatus => {
  if (isOnline == null) return NO_DATA_PLACEHOLDER;
  return isOnline ? 'Online' : 'Offline';
};

type StoreConnectionStatusChipProps = {
  status: StoreConnectionStatus;
};

export const StoreConnectionStatusChip = ({ status }: StoreConnectionStatusChipProps) => {
  const { bgcolor, color } = STATUS_STYLE[status];

  return (
    <Box
      display='inline-flex'
      alignItems='center'
      justifyContent='center'
      sx={{
        alignSelf: 'flex-start',
        bgcolor,
        borderRadius: '4px',
        px: '4px',
        py: '3px',
        width: 44,
      }}
    >
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 600,
          color,
          lineHeight: 'normal',
          whiteSpace: 'nowrap',
        }}
      >
        {status}
      </Typography>
    </Box>
  );
};
